import { takeLatest } from "redux-saga/effects";
import { trackSegmentEvent } from "~/api/choreography";
import { trackSegmentEventSaga } from "~/api/segment/trackSegmentEventSaga";

export function* segmentApiSaga() {
    yield takeLatest(trackSegmentEvent.toString(), trackSegmentEventSaga);
}
